import React from 'react'
import { GeoRiskData } from "../../../Scan/data/MapData";
import FlowChart from 'components/FlowChart/FlowChart';
import MapBox from 'components/MapBox/MapBox';

export default function MapFlow() {
  return (
    <div className="row">
      <div className="col">
        <MapBox
          mapHeight="8rem"
          zoom={2.5}
          showControl={false}
          riskMarkers={GeoRiskData}
        />
      </div>
      <div className="col">
        <FlowChart />
      </div>
    </div>
  );
}
